module.exports = __webpack_public_path__ + "img/DP158.3295baec.png";